/**
 * The mark, as JSX - a die in its package, seen from above. Geometry is the
 * same 24-unit box on a 3.4-unit pin pitch as ui/brand.ts's markSvg (which
 * survives for the favicon string); drawn in currentColor so it inherits.
 */

const PINS_24 = [
  'M8.6 5.6V2.4M12 5.6V2.4M15.4 5.6V2.4',
  'M8.6 18.4V21.6M12 18.4V21.6M15.4 18.4V21.6',
  'M5.6 8.6H2.4M5.6 12H2.4M5.6 15.4H2.4',
  'M18.4 8.6H21.6M18.4 12H21.6M18.4 15.4H21.6',
].join('')

export function BrandMark({ size = 24 }: { size?: number }) {
  return (
    <svg
      viewBox="0 0 24 24"
      width={size}
      height={size}
      aria-hidden="true"
      fill="none"
      stroke="currentColor"
      strokeLinejoin="round"
    >
      <rect x="5.6" y="5.6" width="12.8" height="12.8" rx="1.8" strokeWidth="1.35" />
      <rect x="9.6" y="9.6" width="4.8" height="4.8" fill="currentColor" stroke="none" opacity="0.9" />
      <path d={PINS_24} strokeWidth="1.1" strokeLinecap="round" opacity="0.85" />
    </svg>
  )
}
